export function pipe(a, ...fns) {
    for (const fn of fns) {
        a = fn(a);
    }
    return a;
}
//# sourceMappingURL=pipe.js.map